import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@guards/auth/auth.guard';
import { EvaluationComponent } from './evaluation.component';
import { DeliveryNotesComponent } from './delivery-notes/delivery-notes.component';
import { ChargingStatisticsComponent } from './charging-statistics/charging-statistics.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { RoleGuard } from '@guards/role/role.guard';
import { DeliveryNoteActionsDialogComponent } from '@components/dialog/delivery-note-actions-dialog/delivery-note-actions-dialog.component';
import { DetailsTransactionDialogComponent } from '@components/dialog/details-transaction-dialog/details-transaction-dialog.component';
import { EditDeliveryNotesSettingsDialogComponent } from '@components/dialog/edit-delivery-notes-settings-dialog/edit-delivery-notes-settings-dialog.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'evaluation', component: EvaluationComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: { roles: ['Customer', 'User', 'Account'] },
          children: [
            {
              path: '',
              redirectTo: 'charging-statistics',
              pathMatch: 'full'
            },
            {
              path: 'charging-statistics',
              component: ChargingStatisticsComponent
            },
            {
              path: 'delivery-notes',
              component: DeliveryNotesComponent,
              children: [
                {
                  path: 'edit/:key',
                  component: DeliveryNoteActionsDialogComponent,
                },
                {
                  path: 'settings',
                  component: EditDeliveryNotesSettingsDialogComponent,
                  data: {roles: ['Customer']},
                },
              ]
            },
            {
              path: 'transactions',
              component: TransactionsComponent,
              children: [
                {
                  path: ':key',
                  component: DetailsTransactionDialogComponent,
                }
              ]
            },
          ]
        },
      ]
    )
  ],
  providers: [
  ],
})
export class EvaluationModule { }
